import { format } from "date-fns";
import { Bill } from "../../hooks/AuthContext";
import { Modal } from "../Modal";
import { Header, Container } from "./styles";
import { paymentSituationMap } from "./mocks";

interface IBillDetails {
  bill?: Bill;
  currencyCode?: string;
  period: string;
  isOpen: boolean;
  onRequestClose: () => void;
}

export default function BillDetailsModal({ bill, currencyCode, period, isOpen, onRequestClose }: IBillDetails) {

  function formatDate(date: string) {
    date.replace("Z", "");
    return format(new Date(date), "dd/MM/yyyy");
  }

  const paymentLabel = bill ? paymentSituationMap[bill?.payment_situation] : "Situação desconhecida";

  return (
    <>
      <Modal open={isOpen} onRequestClose={onRequestClose} modalWidth={500}>
        <Header>Detalhes da fatura</Header>
        <Container>
          <div>
            <b>Situação: </b>
            <span>{`${paymentLabel}`}</span>
          </div>
          <div>
            <b>Valor: </b>
            <span>{`${bill?.bill_value} ${currencyCode}`}</span>
          </div>
          <div>
            <b>Período: </b>
            <span>{`${period}`}</span>
          </div>
          {bill?.due_date &&
            <div>
              <b>Vencimento: </b>
              <span>{`${formatDate(String(bill?.due_date))}`}</span>
            </div>
          }
          {bill?.payment_date &&
            <div>
              <b>Data de pagamento: </b>
              <span>{`${bill?.payment_date}`}</span>
            </div>
          }
          {bill?.payment_link && (bill.payment_situation !== 'PAYMENT_RECEIVED' && bill.payment_situation !== 'PAYMENT_CONFIRMED') &&
            < div >
              <a href={bill.payment_link} target="_blank" rel="noreferrer">Clique aqui para acessar sua fatura</a>
            </div>
          }
        </Container>
      </Modal >
    </>
  )
}
